module.exports = __webpack_public_path__ + "img/trash-check.a503fb1a.svg";